<template>
  <tile-grid>
    <service-tile
      v-for="service in getServicesByPlaceAndGroup(getPlace, getServiceGroup)"
      :key="service.id"
      :selected="$_.includes(selectedServices, service.id)"
      :service="service"
      @serviceSelected="serviceSelected"
      @serviceDeselected="serviceDeselected"
    />
  </tile-grid>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import ServiceTile from '@/components/services/service/ServiceTile';
import eventBus from '@/components/utils/slideout-panel/eventBus';
import TileGrid from '@/components/utils/TileGrid';

export default {
  name: 'ServiceGroup',
  mixins: [
    BreadcrumbsManager,
  ],
  props: {
    serviceGroupId: {
      required: true,
      type: Number,
    },
    placeId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      selectedServices: [],
    };
  },
  computed: {
    ...mapGetters([
      'getPlaceById',
      'getPlaceName',
      'getServicesByPlaceAndGroup',
    ]),
    ...mapGetters('service-group', [
      'getServiceGroupById',
    ]),
    ...mapState('app', {
      serviceApp: 'service',
    }),
    getPlace() {
      return this.getPlaceById(this.placeId);
    },
    getServiceGroup() {
      return this.getServiceGroupById(this.serviceGroupId);
    },
    isServicesSelectionEnabled() {
      return this.serviceApp.servicesSelectionEnabled;
    },
    breadcrumbs() {
      const place = this.getPlace;
      const serviceGroup = this.getServiceGroup;
      return [
        {
          text: this.getPlaceName(place.id),
          to: {
            name: 'service-groups',
            params: { placeId: place.id },
          },
        },
        {
          text: serviceGroup.name,
          to: { name: 'service-group', params: { groupId: serviceGroup.id } },
        },
      ];
    },
  },
  methods: {
    serviceSelected(serviceId) {
      this.selectedServices.push(serviceId);
    },
    serviceDeselected(serviceId) {
      this.selectedServices = this.selectedServices.filter(s => s !== serviceId);
    },
  },
  components: {
    ServiceTile, TileGrid,
  },
  mounted() {
    this.selectedServices = [];
  },
  watch: {
    isServicesSelectionEnabled: {
      handler(val) {
        if (!val) {
          this.selectedServices = [];
        }
      },
    },
    selectedServices() {
      eventBus.$emit('servicesSelected', this.selectedServices);
    },
  },
};
</script>

<style scoped>

</style>
